module.exports = __webpack_public_path__ + "static/media/NAPAS.5d73b3aa.svg";